module.exports = __webpack_public_path__ + "img/frame (61).befc42dd.jpg";